import React, { useEffect } from 'react'
import styled from 'styled-components'
import Hero from '../components/Hero/Hero'
import Meta from '../components/Meta'
import TopNav from '../components/TopNav/TopNav'
import Header from '../components/Header/Header'
import ScrolltoTop from '../components/Scrolltotop/ScrolltoTop'
import Footer from '../components/Footer/Footer'
import NewHeader from '../components/NewHeader/NewHeader'
import SubFooter from '../components/SubFooter/SubFooter'
import "./PrivacyPolicy.css"

const PrivacyPolicy = () => {

    useEffect(() => {
        window.scroll({
            top: 0,
            // left: 100,
            behavior: 'smooth'
        });
    }, [])

    return (
        <React.Fragment>
            <Meta
                title="Privacy Policy | Redcliffe Labs"
                description="Redcliffe Labs follows a very transparent privacy policy and they understand user privacy and maintain it very strictly."
            >
                <meta property="og:title" content="Privacy Policy | Redcliffe Labs" />
                <meta property="og:site_name" content="Redcliffe Labs" />
                <meta property="og:url" content="https://redcliffelabs.com/privacy" />
                <meta property="og:description" content="Redcliffe Labs follows a very transparent privacy policy and they understand user privacy and maintain it very strictly." />
                <meta property="og:type" content="Diagnostic Centre" />
                <meta property="og:image" content="https://redcliffelabs.com/OG-Twitter-Card.jpg" />

                <meta name="twitter:card" content="summary" />
                <meta name="twitter:site" content="Redcliffe Labs" />
                <meta name="twitter:title" content="Privacy Policy | Redcliffe Labs" />
                <meta name="twitter:description" content="Redcliffe Labs follows a very transparent privacy policy and they understand user privacy and maintain it very strictly." />
                <meta name="twitter:image" content="https://redcliffelabs.com/OG-Twitter-Card.jpg" />
            </Meta>
            <NewHeader />
            <Hero text="Redcliffe Labs PRIVACY POLICY" link="Privacy Policy" />
            <div className="container">
                <div className="PrivacyPolicyWrapper">
                    <div className="col-xs-12">
                        <div className="research-details-desc">
                            <h3>Information collected by Redcliffe Labs</h3>
                            <p>This Privacy Policy is a substantial part of the contractual conformity between you and
                                redcliffelabs.com (“redcliffelabs.com”, “Redcliffe Labs'', “us”, “we”, “our'',
                                “Company”, “Website”), which you agreed to while using/browsing/ visiting “redcliffelabs.com”
                                Website or elsewhere or used any other technology system or gateway offered by Redcliffe Life
                                Diagnostics (which owns and operates redcliffelabs.com) or its affiliates. This Policy
                                ascertains the methods we or our vendors/partners gather, protect, use and store your data. You
                                agree to this Privacy Policy when you use our products and services on any of the platforms
                                including the website. If you do not agree to this Privacy Policy, you can opt not to use the
                                redcliffelabs.com Website or any of our services.
                            </p>
                            <p>Redcliffe Labs Privacy Policy precisely presents the way it collects users’
                                information and data through http://redcliffelabs.com/. By agreeing to Redcliffe Life
                                Diagnostics you agree to allow it to access your information. Kindly read our Privacy Policy
                                carefully.
                            </p>
                            <p>In case you have any questions regarding the terms or conditions mentioned herein, you can
                                contact Redcliffe Labs customer support at care@redcliffelabs.com.
                            </p>
                            <h3>Information shared by the Users
                            </h3>
                            <p>We gather the following "personal information" about users online where they voluntarily agree to
                                provide it to us through our website:</p>
                            <ul>
                                <li>
                                    <p>Acknowledgment</p>
                                </li>
                                <li>
                                    <p>First Name, Last Name</p>
                                </li>
                                <li>
                                    <p>Email details</p>
                                </li>
                                <li>
                                    <p>Age</p>
                                </li>
                                <li>
                                    <p>Gender</p>
                                </li>
                                <li>
                                    <p>Location</p>
                                </li>
                                <li>
                                    <p>Contact Number</p>
                                </li>
                                <li>
                                    <p>Postal Code</p>
                                </li>
                                <li>
                                    <p>Financial Information – online transaction details, bank account details, email address,
                                        and physical address</p>
                                </li>
                            </ul>
                            <h3>How we use your information</h3>
                            <p>Redcliffe Labs gathers your personal information for a variety of authoritarian and
                                business requirements. It includes, but is not limited to:</p>
                            <ul>
                                <li>
                                    <p>Examine and provide report results for the tests desired by patients</p>
                                </li>
                                <li>
                                    <p>Resolve your queries for service, support, or assistance</p>
                                </li>
                                <li>
                                    <p>Information related to age & gender to provide reports accurately
                                    </p>
                                </li>
                                <li>
                                    <p>Provide, preserve and improve our services
                                    </p>
                                </li>
                                <li>
                                    <p>Maintain social history as directed by prevailing law or policy
                                    </p>
                                </li>
                                <li>
                                    <p>Ensure observance of legal and regulatory needs for deterrence and revelation of frauds
                                        and crimes
                                    </p>
                                </li>
                                <li>
                                    <p>Analyze our services and products and carry out customer surveys </p>
                                </li>
                                <li>
                                    <p>To permit for debugging, testing, and otherwise control our platforms</p>
                                </li>
                                <li>
                                    <p>We may also use your information to access your data stored by third-party platforms
                                        including and social media sites like (Facebook, Instagram, Twitter, Truecaller,
                                        LinkedIn, etc.)
                                    </p>
                                </li>
                            </ul>
                            <h3>
                                How we use your email address and contact number
                            </h3>
                            <ul>
                                <li><p>Registration confirmation and password reminder</p></li>
                                <li><p>Intimation of changes in the privacy policy or terms and condition</p></li>
                                <li><p>Special communication related to order information, delivery information, etc</p></li>
                                <li><p>Occasional offers, if any send exclusive offers and information regarding new product launch, Services and general info</p></li>
                                <li><p>Redcliffe life diagnostic doesn’t disclose its users’ personal information to any third party, unless:</p>
                                </li>
                                    <ul >
                                        <li><p>it is important for providing services to or you have allowed us to do so,</p></li>
                                        <li><p>we are legally eligible to do so, i.e. in the fulfillment of regulatory needs or agreement to the court order or other legal/quasi permissible process, and/or
                                        </p></li>
                                        <li><p>it is important to do so for protecting and securing the rights or property of this website. We are not liable for any personal information which is usually accessible to the general public
                                        </p></li>
                                    </ul>
                                
                                <li><p>By agreeing to this Privacy Policy, you are also allowing us to share or aggregate, non-personal data about website usage with certain third parties. This summative information does not comprise any personal data about the users. We take ample measures to make sure that our third parties take up the practical and sensible level of security processes to ensure the safety of users’ data
                                </p></li>
                            </ul>

                            <h3>European Union (EU) privacy/data protection rights</h3>
                            <ul>
                                <li><p>EU General Data Protection Regulation (GDPR) has provided the below rights to the EU residents:</p></li>

                                <li><p>Right to information - including contact details to the DPO, the purposes for processing Personal Information and the rights of the individual.</p></li>

                                <li><p>Right to access the Personal Information that are processed.</p></li>

                                <li><p>Right to erasure (”Right to be forgotten”).</p></li>

                                <li><p>Right to rectification.</p></li>

                                <li><p>Right to restriction of processing.</p></li>

                                <li><p>Right to data portability of the Personal Information supplied to us by the EU resident.</p></li>

                                <li><p>Right to object (opt-out) to processing (unless otherwise we have compelling legitimate grounds).</p></li>

                                <li><p>EU residents can exercise these rights by raising a request directly at care@redcliffelabs.com or contact us at the information provided in the 'Data Protection, Privacy & Grievance Support' section with specific requirements.</p></li>
                            </ul>                                            

                            <h3>Data Protection, Privacy & Grievance Support</h3>
                            <ul>
                                <li><p>For any enquiry or a complaint about the how we manage and use your personal information,</p></li>
                                <li>
                                    <p>or to seek to exercise your privacy rights in regards to the personal information we take care about your information
                                    </p>
                                </li>
                                <li>
                                    <p> you may contact our Data Protection, Privacy & Grievance Support team as follows:</p>
                                </li>
                            </ul>
                            <ul>
                                <li><p>By Email : grievance@redcliffelabs.com</p></li>
                                <li><p>By Mail : H55, Electronic City, Sec 63, Noida 201301</p></li>
                                <li><p>Grievance Officer : Prince Wadhwa</p></li>
                                
                            </ul>

                            <h3>How we access your reports or data</h3>
                            <ul>
                                <li><p>In some cases, patients’ reports and information is shared with physicians or healthcare professionals for proper diagnosis and treatment</p></li>
                                <li>
                                    <p>Patients’ report is used for billing purposes and we may also share it with insurance companies, healthcare departments, physicians for payment rationale. We ensure that patients’ privacy is protected in the process
                                    </p>
                                </li>
                                <li>
                                    <p>We may access your information or reports to carry our healthcare-related activities like performing a quality check for testing and quality analyses purposes</p>
                                </li>
                            </ul>
                            
                            <h3>Links to third-party websites </h3>
                            <p>On our website, you will come across several links to third-party platforms. These links may be our company, or they may appear as content that other users generate. These linked third-party platforms are not under our control and thus we are not accountable for their actions. Before providing your data through any other website, you should analyze the terms and conditions of that website.</p>
                            <h3>Transfer of user data</h3>
                            <p>We may transfer the data shared by you in the event of a transfer of ownership of Redcliffe Labs or the attainment of substantially all the assets of Redcliffe Labs related to the owner which collected such information, like acquisition by or a merger with another company. When any such thing happens, Redcliffe Labs will inform users who have provided email addresses.
                            </p>
                            <h3>Amendments to the Privacy Policy
                            </h3>
                            <p>Redcliffe Labs reserves all the rights to amend modifications/changes to this Privacy Policy, and any of its other processes regarding the treatment of data collected through the Website, without prior notice. Any modifications to this Privacy Policy will become effective upon posting the modified Privacy Policy on the Website.
                            </p>
                            <h3>Cookies Policy</h3>
                            <p>When you use services offered by Redcliffe Labs, it sends "cookies" to your device or computer when you access the Website and the Services such cookies as explained here. The services use cookies to advance the quality of our website, build recommendations, and make the experiences for the users easier for our members. Cookies are a small text file recorded on users’ hard drive or smartphone that classifies them as an inimitable user and comprises certain information about their specific login session and/or their use of the Services.
                            </p>
                            <h3>
                                Contact Us
                            </h3>
                            <p>For any queries regarding our terms of service or privacy policy, you can contact us to get your queries resolved. You can also submit your request or query regarding our terms of services or privacy policy at: care@redcliffelabs.com
                            </p>
                            <h3>Office Address:
                            </h3>
                            <p> H-55, Sector 63 Road, A Block, Electronic City, Noida, Uttar Pradesh 201301.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <ScrolltoTop />
            <Footer />
            <SubFooter />
        </React.Fragment>
    )
}


export default {
    component: PrivacyPolicy
}
